<template>
    <div id="subscription-confirmation-dialog-component">
        <v-dialog :value="value" max-width="500px" @input="$emit('input', $event)">
            <v-card class="mx-auto relative">
                <v-card-title class="font-weight-bold pb-4">
                    <span :class="titleColorClass">{{ title }}</span>
                </v-card-title>

                <v-card-text class="pb-0">
                    <p v-if="message" :class="[messageColorClass, 'mb-0']" v-html="$t(message)"></p>
                    <p v-if="subMessage" :class="['mt-2 font-italic', messageColorClass]">({{ $t(subMessage) }})</p>
                </v-card-text>

                <v-card-actions class="justify-end pb-4">
                    <v-btn color="accent" text @click="$emit('cancel')" rounded elevation="0">
                        <span class="font-weight-bold">{{ $t('global.cancel') }}</span>
                    </v-btn>
                    <v-btn
                        :loading="loading"
                        :class="buttonClass + ' px-4 py-2'"
                        :color="buttonColor"
                        @click="$emit('confirm')"
                        rounded
                        elevation="0"
                    >
                        <span :class="['font-weight-bold', buttonTextClass]">{{ $t('global.validate') }}</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'SubscriptionConfirmationDialogComponent',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            required: true,
        },
        message: {
            type: String,
            default: '',
        },
        subMessage: {
            type: String,
            default: '',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        variant: {
            type: String,
            default: 'default',
            validator: (value) => ['default', 'danger'].includes(value),
        },
    },

    computed: {
        titleColorClass() {
            return this.variant === 'danger' ? 'red--text' : 'font-color-medium'
        },
        messageColorClass() {
            return this.variant === 'danger' ? 'red--text' : 'font-color-medium'
        },
        buttonClass() {
            return this.variant === 'danger' ? '' : 'btn-secondary-loader font-weight-bold'
        },
        buttonColor() {
            return this.variant === 'danger' ? 'red' : 'primary'
        },
        buttonTextClass() {
            return this.variant === 'danger' ? 'white--text' : 'secondary--text'
        },
    },
}
</script>
